import { Injectable } from '@angular/core';
import { BaseClientService } from './base-client.service';
import { ErrorModel } from '../../model/error.model';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { Observable, of as observableOf, throwError, Subject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class ContatoAssistencialService {
    constructor(
        private client: BaseClientService,
    ) {
    }



    request(req, payload?): Observable<any>{
        const request$ = this.client.get<any>(req, payload).pipe(
            take(1),
            catchError((error: ErrorModel) => {
              if (error.code === 401) {
                console.warn('[AuthService::isAuthenticated] Não está autenticado');
              } else if (error.code === 403) {
                console.warn('[AuthService::isAuthenticated] Acesso proíbido cadastrado');
              } else {
                console.log('error====', error);
                console.warn('[AuthService::isAuthenticated] Ops, erro na verificação', error);
              }
              return throwError(error);
            }),
            map((result: any) => {
              console.log('[AuthService::isAuthenticated] Acessou a URL do backend de boa!', result);
              if (!result) {
                throw result;
              }
              return result;
            }),
          );
        return request$;
    }

    postRequest(req, payload?): Observable<any>{
        const request$ = this.client.post(req, payload).pipe(
            take(1),
            catchError((error: ErrorModel) => {
              if (error.code === 401) {
                console.warn('[AuthService::isAuthenticated] Não está autenticado');
              } else if (error.code === 403) {
                console.warn('[AuthService::isAuthenticated] Acesso proíbido cadastrado');
              } else {
                console.warn('[AuthService::isAuthenticated] Ops, erro na verificação', error);
              }
              return throwError(error);
            }),
            map((result: any) => {
              console.log('[AuthService::isAuthenticated] Acessou a URL do backend de boa!', result);
              if (!result) {
                throw result;
              }
              return result;
            }),
          );
        return request$;
    }

    deleteRequest(req, payload?): Observable<any>{
      const request$ = this.client.delete(req, payload).pipe(
          take(1),
          catchError((error: ErrorModel) => {
            if (error.code === 401) {
              console.warn('[AuthService::isAuthenticated] Não está autenticado');
            } else if (error.code === 403) {
              console.warn('[AuthService::isAuthenticated] Acesso proíbido cadastrado');
            } else {
              console.warn('[AuthService::isAuthenticated] Ops, erro na verificação', error);
            }
            return throwError(error);
          }),
          map((result: any) => {
            console.log('[AuthService::isAuthenticated] Acessou a URL do backend de boa!', result);
            if (!result) {
              throw result;
            }
            return result;
          }),
        );
      return request$;
  }


    getJustificativa(): Observable<any> {
        return this.request(`/justificativa-ausencia-cns`);
    }

    getModalidadeAssistencial(): Observable<any> {
        return this.request(`/modalidade-assistencial`);

    }

    getCaraterAtendimento(): Observable<any> {
        return this.request(`/carater-atendimento`);

    }

    getMotivoDesfecho(): Observable<any> {
        return this.request(`/desfecho`);

    }

    getContatoDiagnostico(): Observable<any> {
        return this.request(`/contato-diagnostico`);

    }

    getFicnanciamento(): Observable<any> {
        return this.request(`/financiamento`);

    }

    getProcedimentos(payload): Observable<any> {
        return this.postRequest(`/procedimentos`, payload);

    }

    getProblemaDiagnostico(req, payload): Observable<any> {
        return this.postRequest(req, payload);

    }

    getEquipe(payload): Promise<any> {
        return this.postRequest(`/equipe/paginado`, payload).toPromise();
    }

    postContatoAssistencial(payload): Observable<any> {
        return this.postRequest(`/contato-assistencial`, payload);

    }
    postDiagnosticoAssistencial(payload): Observable<any> {
        return this.postRequest(`/contato-diagnostico`, payload);

    }
    getContatoAssistencial(payload): Observable<any> {
        return this.postRequest(`/contato-assistencial/paginado`, payload);
    }
    getOne(id): Observable<any> {
        return this.request(`/contato-assistencial/${id}`);
    }

    deleteContatoAssistencial(id): Observable<any> {
      return this.deleteRequest(`/contato-assistencial/${id}`);
  }

}
